import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_19: FaireProductEntity = {
  token: "atc_fs_19",
  type: "product",
  name: "Power Mist Lavender",
  brandName: "Touchland",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c27a4d1c220729290822c4da0f11afc7ca89a97f830d7010e62e8fe1c040ed47.webp",
  priceDollars: 10,
  msrpDollars: 20,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
